import { OriginConnectionPosition, Overlay, OverlayConnectionPosition, OverlayRef, PositionStrategy } from '@angular/cdk/overlay';
import { ComponentPortal, PortalInjector } from '@angular/cdk/portal';
import { ElementRef, Injectable, Injector } from '@angular/core';
import { Store } from '@ngxs/store';
import { ChangeWizardTodoStatus } from '../state/base/base.actions';
import { HelperWizardPopupComponent, PORTAL_DATA } from './../../theme/components/helper-wizard-popup/helper-wizard-popup.component';
import { CommonService } from './../../theme/pages/home/_services/common.service';
import { StorageService } from './storage.service';

@Injectable({
    providedIn: 'root',
})
export class OverlayService {
    public overlayRef: OverlayRef;
    constructor(
        private overlay: Overlay,
        private injector: Injector,
        private commonRest: CommonService,
        private storage: StorageService,
        private store: Store,
    ) {}

    private createInjector(data): PortalInjector {
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const injectorTokens = new WeakMap<any, any>([[PORTAL_DATA, data]]);

        return new PortalInjector(this.injector, injectorTokens);
    }

    public open(
        elementRef: ElementRef,
        showButton: boolean = true,
        overlayId: number,
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/ban-types
        simpleOverlaySettings: Object,
        targetRefData?: {
            targetRef: ElementRef;
            originXY?: OriginConnectionPosition;
            overlayXY?: OverlayConnectionPosition;
        },
        globalPositionConfig?: string[],
    ) {
        this.overlayRef?.dispose();

        //elementRef--> content ki ga prikazuješ v popupu (ElementRef)
        //targetRef --> na kateri element boš pripel popup(elementRef) za boljšo pozicijo (ElementRed) (optional)
        //originXY  --> pozicija, če imaš targetRef definiran (optional)
        //overlayXY --> pozicija, če imaš targetRef definiran (optional)
        //globalPositionConfig --> pozicija, če nimaš targetRef definiran. primer: ['left100px','top200px'] -> popup ima levo odmika 100px, top odmika 200px (optional)
        //position: https://stackoverflow.com/questions/52432447/angular-cdk-understanding-the-overlay-position-system

        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let position: PositionStrategy | any;
        if (targetRefData?.targetRef) {
            position = this.overlay
                ?.position()
                .flexibleConnectedTo(targetRefData?.targetRef)
                .withPositions([
                    {
                        originX: targetRefData?.originXY?.originX || 'start',
                        originY: targetRefData?.originXY?.originY || 'top',
                        overlayX: targetRefData?.overlayXY?.overlayX || 'start',
                        overlayY: targetRefData?.overlayXY?.overlayY || 'top',
                    },
                ]);
        } else {
            if (globalPositionConfig) {
                globalPositionConfig?.forEach(action => {
                    switch (action) {
                        case 'centerH':
                            if (!position) {
                                position = this.overlay.position().global().centerHorizontally();
                            } else {
                                position?.centerHorizontally();
                            }
                        // TODO Ignored with eslint-interactive on 2023-11-10
                        // eslint-disable-next-line no-fallthrough
                        case 'centerV':
                            if (!position) {
                                position = this.overlay.position().global().centerVertically();
                            } else {
                                position?.centerVertically();
                            }
                        // TODO Ignored with eslint-interactive on 2023-11-10
                        // eslint-disable-next-line no-fallthrough
                        default:
                            if (action.includes('right')) {
                                if (!position) {
                                    position = this.overlay.position().global().right(action.split('right')[1]);
                                } else {
                                    position?.right(action.split('right')[1]);
                                }
                            } else if (action.includes('left')) {
                                if (!position) {
                                    position = this.overlay.position().global().left(action.split('left')[1]);
                                } else {
                                    position?.left(action.split('left')[1]);
                                }
                            } else if (action.includes('top')) {
                                if (!position) {
                                    position = this.overlay.position().global().top(action.split('top')[1]);
                                } else {
                                    position?.top(action.split('top')[1]);
                                }
                            } else if (action.includes('bottom')) {
                                if (!position) {
                                    position = this.overlay.position().global().bottom(action.split('bottom')[1]);
                                } else {
                                    position?.bottom(action.split('bottom')[1]);
                                }
                            }
                    }
                });
            }
        }
        //create overlay
        this.overlayRef = this.overlay.create({
            hasBackdrop: true,
            positionStrategy: position,
            scrollStrategy: this.overlay?.scrollStrategies?.reposition(),
        });
        //inject data into component
        const componentPortal = new ComponentPortal(
            HelperWizardPopupComponent,
            null,
            this.createInjector({
                ...elementRef,
                showButton: showButton,
                overlayId: overlayId,
                simpleOverlaySettings: simpleOverlaySettings,
            }),
        );
        const overlayComponent = this.overlayRef?.attach(componentPortal);
        //closing the overlay
        if (showButton) {
            //gumb OK prikazan --> ugasni overlay samo preko klika gumba
            overlayComponent?.instance?.closeClick?.subscribe((dontShowAgain: boolean) => {
                if (dontShowAgain) {
                    this.dontShowOverlayAgain(overlayId);
                }
                this.overlayRef?.dispose();
            });
        } else {
            //gumb OK ni prikazan --> ugasni overlay s klikom izven overlaya
            this.overlayRef.backdropClick().subscribe(() => {
                this.overlayRef?.dispose();
            });
        }
    }

    public dontShowOverlayAgain(wizardId: number) {
        this.store.dispatch(new ChangeWizardTodoStatus({ completed: true, id: wizardId }));
    }
}
